import { memo } from 'react'
import { DEFAULT_RESUBMIT_TIME } from '../../../constants/app'
import { useSubmitAction } from '../../../hooks/useSubmitAction'

const CustomForm = ({
  children,
  onFormSubmit,
  resubmitTime = DEFAULT_RESUBMIT_TIME
}) => {
  const handleOnSubmit = useSubmitAction(resubmitTime, (e) => {
    if (onFormSubmit) {
      onFormSubmit(e)
    }
  })
  return (
    <form onSubmit={handleOnSubmit} noValidate>
      {children}
    </form>
  )
}

export default memo(CustomForm)
